<template>
  <div class="card-multipliers">
    <div
      v-for="(multiplier, i) in multipliers"
      :key="i"
      class="multiplier"
    >
      <div class="card-search-container">
        <template v-if="multipliers[i].card">
          <card-list-item
            :card="multipliers[i]"
            :fields="['currentValue']"
            :custom-fields="[{
              label: 'Multiplier',
              value: `${$filters.decimal(multipliers[i].value)}x`,
            }]"
          />

          <div v-if="multipliers[i].results" class="results">
            <span>{{ multipliers[i].results }}</span>
          </div>
        </template>

        <card-search
          v-else
          placeholder="Search for a card"
          @select="setMultiplier(i, $event)"
        />
      </div>

      <align v-show="multipliers[i].card" flex>
        <text-input
          v-model="multipliers[i].value"
          type="decimal"
          label="Multplier ratio"
        />

        <btn class="remove" kind="secondary" @click="removeMultiplier(i)">
          {{ removeText }}
        </btn>
      </align>
    </div>

    <add-link
      v-if="multipliers && multipliers.length < limit && hasCompleteMultiplier"
      class="icon-link"
      @click="addMultiplier"
    >
      Add another multiplier
    </add-link>

    <div v-show="estimatedValue && hasCompleteMultiplier" class="estimated-value">
      <span>Estimated Value:</span> <b>{{ $filters.currency(estimatedValue, { full: true }) }}</b>
    </div>
  </div>
</template>

<script>
import { getEstimatedValueFromMultipliers, getMultiplierResults } from '@cardladder/shared/utils/collection.util';

import CardListItem from '@cardladder/shared/components/CardListItem';

import CardSearch from '@/cards/CardSearch';

import { cardService, saleService } from '@/services';

export default {
  components: {
    CardListItem,
    CardSearch,
  },

  props: {
    value: Array,
    card: Object,
    limit: {
      type: Number,
      default: 5,
    },
    removeText: {
      type: String,
      default: 'Remove this card',
    },
  },

  data() {
    return {
      multipliers: this.value,
      estimatedValue: null,
    };
  },

  mounted() {
    this.addEmpty();

    if (this.multipliers && this.multipliers.length > 0) {
      this.setEstimatedValue();
    }
  },

  watch: {
    multipliers: {
      handler(value) {
        this.$emit('input', value);
        this.addEmpty();
        this.setEstimatedValue();
      },
      deep: true,
    },

    value: {
      handler(value) {
        this.multipliers = value;
      },
      deep: true,
    },
  },

  computed: {
    hasCompleteMultiplier() {
      return this.multipliers?.some(({ card, value }) => Boolean(card && value));
    },
  },

  methods: {
    addEmpty() {
      if (!this.multipliers || this.multipliers.length === 0) {
        this.addMultiplier();
      }
    },

    addMultiplier() {
      if (!this.multipliers) {
        this.multipliers = [];
      }

      this.multipliers.push({ card: null, value: 1 });
    },

    removeMultiplier(i) {
      this.multipliers.splice(i, 1);
    },

    async setMultiplier(i, card) {
      let multiplierRatio = 1;
      let results = '';

      const multiplierResults = await getMultiplierResults(this.card, card.id, card.currentValue, saleService);

      multiplierRatio = multiplierResults.value;
      results = multiplierResults.text;

      this.multipliers[i].card = card.id;
      this.multipliers[i].value = multiplierRatio;
      this.multipliers[i].cardLabel = card.label;
      this.multipliers[i].results = results;
      this.multipliers[i].id = card.id;
      this.multipliers[i].image = card.image || '';
      this.multipliers[i].year = card.year || '';
      this.multipliers[i].set = card.set || '';
      this.multipliers[i].condition = card.condition || '';
      this.multipliers[i].player = card.player || '';
      this.multipliers[i].number = card.number || '';
      this.multipliers[i].variation = card.variation || '';
      this.multipliers[i].currentValue = card.currentValue || null;
    },

    async setEstimatedValue() {
      const { estimatedValue } = await getEstimatedValueFromMultipliers(this.multipliers, cardService);

      this.estimatedValue = estimatedValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.remove,
.card-search-container,
.icon-link  {
  margin-bottom: $gp;
}

.results {
  font-size: 12px;
}

.estimated-value {
  margin-bottom: $gp;
}

.card-list-item {
  padding: 0;
  margin-bottom: $gp * .5;
}
</style>
